import React from 'react';
import DeletedFileSessionRow from './deletedFileSessionRow.component';
import { ExpansionPanel, ExpansionPanelDetails,TableCell,Table,TableHead, ExpansionPanelSummary, Typography, TableRow, TableBody  } from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import _ from 'lodash';
const styles = () => ({
  root: {
    border: "none",
    boxShadow: "none",
    padding: "0"
  },
  title: {
    margin: "5px 0px"
  },
  table: {
    minWidth: "100%"
  },
  lastTable: {
    minWidth: "100%",
    marginBottom: "50px"
  },
  insidepanel: {
    padding: "0px"
  },
  spacing: {
    margin: "9px 0"
  }

});

const deletedFiles = ({session,classes}) =>{
  const files = _.filter(
    session.files,
    file => !file.active && !file.missing
  );

  const renderDeletedTableRows = () => {
      return files.map(file => (
          <DeletedFileSessionRow
            key={file.id}
            sessionId={session.id}
            row={file}
          />
        ))
  }
  return files.length > 0 ? (
    <ExpansionPanel className={classes.root}>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.title} variant="subtitle1">
          Deleted Files ({files.length})
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.insidepanel}>
        <Table className={classes.lastTable} aria-labelledby="tableTitle">
          <TableHead>
            <TableRow>
              <TableCell>Filename</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderDeletedTableRows()}</TableBody>
        </Table>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  ) : (
    ""
  );

}

export default withStyles(styles)(deletedFiles);
